import merge from 'lodash/merge';
import { Dimensions, StyleSheet } from 'react-native';
import { BLUE_700, tokens, tooltipConfig } from '../../constants';
import { scale } from '../../utils';
var getTooltipContainerStyles = (props, position, layouts, isLargeScreen) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
  var tooltipWidthDesktop = props.tooltipWidthDesktop,
    tooltipWidthMobile = props.tooltipWidthMobile,
    withScaling = props.withScaling;
  var tooltipHeight = ((_a = layouts === null || layouts === void 0 ? void 0 : layouts.tooltip) === null || _a === void 0 ? void 0 : _a.height) || 0;
  var tooltipWidth = ((_b = layouts === null || layouts === void 0 ? void 0 : layouts.tooltipContainer) === null || _b === void 0 ? void 0 : _b.width) || 0;
  var childrenWidth = ((_c = layouts === null || layouts === void 0 ? void 0 : layouts.children) === null || _c === void 0 ? void 0 : _c.width) || 0;
  var childrenHeight = ((_d = layouts === null || layouts === void 0 ? void 0 : layouts.children) === null || _d === void 0 ? void 0 : _d.height) || 0;
  var offsetX = ((_e = props === null || props === void 0 ? void 0 : props.offset) === null || _e === void 0 ? void 0 : _e.x) || 0;
  var offsetY = ((_f = props === null || props === void 0 ? void 0 : props.offset) === null || _f === void 0 ? void 0 : _f.y) || 0;
  var offsetStart = ((_g = props === null || props === void 0 ? void 0 : props.offset) === null || _g === void 0 ? void 0 : _g.start) || 0;
  var offsetCenter = ((_h = props === null || props === void 0 ? void 0 : props.offset) === null || _h === void 0 ? void 0 : _h.center) || 0;
  var offsetEnd = ((_j = props === null || props === void 0 ? void 0 : props.offset) === null || _j === void 0 ? void 0 : _j.end) || 0;
  var offsetTop = ((_k = props === null || props === void 0 ? void 0 : props.offset) === null || _k === void 0 ? void 0 : _k.top) || 0;
  var offsetBottom = ((_l = props === null || props === void 0 ? void 0 : props.offset) === null || _l === void 0 ? void 0 : _l.bottom) || 0;
  var offsetLeft = ((_m = props === null || props === void 0 ? void 0 : props.offset) === null || _m === void 0 ? void 0 : _m.left) || 0;
  var offsetRight = ((_o = props === null || props === void 0 ? void 0 : props.offset) === null || _o === void 0 ? void 0 : _o.right) || 0;
  var SAFE_SPACE = tokens.spacing.SPACING_14;
  var _position$split = position.split('-'),
    vertical = _position$split[0],
    horizontal = _position$split[1];
  var leftAndRightVertical = vertical == 'left' || vertical == 'right';
  var styles = {
    top: {
      top: -(tooltipHeight + offsetY + SAFE_SPACE * 2) + offsetTop
    },
    bottom: {
      bottom: -(tooltipHeight + offsetY + SAFE_SPACE * 2) + offsetBottom
    },
    start: Object.assign({}, !leftAndRightVertical && {
      left: 0 + offsetX + offsetStart
    }),
    center: Object.assign({}, !leftAndRightVertical ? {
      left: -(tooltipWidth / 2 - childrenWidth / 2) + offsetCenter
    } : {
      top: -(tooltipHeight / 2 - childrenHeight / 2) + offsetCenter
    }),
    end: Object.assign({}, leftAndRightVertical ? {
      top: tooltipHeight + offsetY + SAFE_SPACE * 2 + offsetTop
    } : {
      right: 0 + offsetX + offsetEnd
    }),
    left: {
      left: -(tooltipWidth + offsetX + SAFE_SPACE) + offsetLeft
    },
    right: {
      right: -(tooltipWidth + offsetX + SAFE_SPACE) + offsetRight
    }
  };
  var desktopWidth = tooltipWidthDesktop || Dimensions.get('window').width / 2;
  var defaultTooltipWidthMobile = tooltipWidthMobile || Dimensions.get('window').width * 0.5;
  var mobileWidth = withScaling ? scale(defaultTooltipWidthMobile) : defaultTooltipWidthMobile;
  return Object.assign(Object.assign(Object.assign({}, styles[vertical]), styles[horizontal]), {
    width: isLargeScreen ? desktopWidth : mobileWidth
  });
};
var getTooltipCarrotStyles = (position, isReverseCarrot, layouts) => {
  var _a, _b;
  var commonStyles = {
    position: 'absolute',
    alignSelf: 'flex-start',
    height: 12,
    width: 12,
    borderRadius: 2,
    transform: [{
      rotate: '45deg'
    }]
  };
  var tooltipHeight = ((_a = layouts === null || layouts === void 0 ? void 0 : layouts.tooltip) === null || _a === void 0 ? void 0 : _a.height) || 0;
  var childrenHeight = ((_b = layouts === null || layouts === void 0 ? void 0 : layouts.children) === null || _b === void 0 ? void 0 : _b.height) || 0;
  var _position$split2 = position.split('-'),
    vertical = _position$split2[0],
    horizontal = _position$split2[1];
  var leftAndRightVertical = vertical == 'left' || vertical == 'right';
  var styles = {
    top: {
      [isReverseCarrot ? 'top' : 'bottom']: -tokens.spacing.SPACING_4
    },
    bottom: {
      [isReverseCarrot ? 'bottom' : 'top']: -tokens.spacing.SPACING_4
    },
    start: Object.assign({}, !leftAndRightVertical && {
      left: tokens.spacing.SPACING_16
    }),
    center: Object.assign({
      alignSelf: 'center'
    }, leftAndRightVertical && {
      top: -(tooltipHeight / 2 - childrenHeight / 2),
      bottom: -(tooltipHeight / 2 - childrenHeight / 2)
    }),
    end: {
      [leftAndRightVertical ? 'top' : 'right']: tokens.spacing.SPACING_16
    },
    left: {
      [isReverseCarrot ? 'left' : 'right']: -tokens.spacing.SPACING_4
    },
    right: {
      [isReverseCarrot ? 'right' : 'left']: -tokens.spacing.SPACING_4
    }
  };
  return Object.assign(Object.assign(Object.assign({}, commonStyles), styles[vertical]), styles[horizontal]);
};
export var getTooltipStyles = (props, layouts, isLargeScreen) => {
  var position = props.position,
    _props$config = props.config,
    config = _props$config === void 0 ? {} : _props$config,
    _props$isReverseCarro = props.isReverseCarrot,
    isReverseCarrot = _props$isReverseCarro === void 0 ? false : _props$isReverseCarro,
    backgroundColor = props.backgroundColor;
  var tooltipContainerStyles = getTooltipContainerStyles(props, position, layouts, isLargeScreen);
  var carrotStyles = getTooltipCarrotStyles(position, isReverseCarrot, layouts);
  var alignSelf = 'flex-start';
  var horizontal = position.split('-')[1];
  if (horizontal === 'center') alignSelf = 'center';
  if (horizontal === 'end') alignSelf = 'flex-end';
  return StyleSheet.create({
    container: {
      position: 'relative',
      zIndex: 999
    },
    children: {
      position: 'relative',
      zIndex: 0
    },
    tooltipContainer: Object.assign({
      position: 'absolute',
      zIndex: 1
    }, tooltipContainerStyles),
    tooltipContent: Object.assign({
      position: 'relative',
      alignSelf,
      backgroundColor
    }, config),
    tooltipBody: {
      flexDirection: 'row'
    },
    carrot: Object.assign(Object.assign({}, carrotStyles), {
      backgroundColor
    }),
    tooltip: {
      flexDirection: 'row'
    },
    cross: {
      marginLeft: tokens.spacing.SPACING_4
    },
    icon: {
      marginRight: tokens.spacing.SPACING_4,
      flexShrink: 0
    },
    descriptionContent: {
      flexDirection: 'column',
      flexShrink: 1,
      flexGrow: 1
    },
    descriptionContainer: {
      flexDirection: 'row'
    },
    content: {
      flexDirection: 'column',
      flexShrink: 1
    },
    stepCtaContainer: {
      flexDirection: 'row',
      marginTop: tokens.spacing.SPACING_8,
      justifyContent: 'flex-end'
    },
    ctaContainer: {
      flexDirection: 'row'
    },
    counterText: {
      flexShrink: 0,
      flexGrow: 1,
      alignSelf: 'center'
    },
    ctaStyles: {
      marginLeft: tokens.spacing.SPACING_4,
      paddingVertical: tokens.spacing.SPACING_5,
      paddingHorizontal: tokens.spacing.SPACING_8
    },
    primaryCtaStyle: {
      backgroundColor: BLUE_700,
      borderRadius: tokens.borderRadius.BORDER_RADIUS_4
    }
  });
};
export var getTooltipProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(tooltipConfig === null || tooltipConfig === void 0 ? void 0 : tooltipConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.tooltip) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};